import React, { useEffect } from 'react'
import { useState } from 'react'
import getMovieDetailsFromWikiService from '../../Services/Queries/GetMovieDetaisFromWikiService'
import getPersondata from '../../Services/Queries/GetPersondata'
import CreatePerson from '../Person/CreatePerson'
import EditMovie from '../Movie/EditMovie'
function ImportMovies() {
	const [trueval, settrueval] = useState(false)
	const [inputArr, setInputArr] = useState([])
	const [movesinput, setMovesinput] = useState('')
	const [wikkedata, setwikkedata] = useState()
	const [accordian, setaccordian] = useState(false)
	const [arrayofobjForpersons, setarrayofobjForpersons] = useState([])
	const [boolToCall, setboolToCall] = useState()
	const [dataFromWiki, setdataFromWiki] = useState()
	const [persondata, setpersondata] = useState()

	function Inputtextmovies(e) {
		setMovesinput(e.target.value)
	}
	// const submitform=async () =>{
	// 	const data = await getMovieDetailsFromWikiService()

	// }
	// let aValue
	const multidataarray = output => {
		console.log('enterefd')
		const aValue = [...arrayofobjForpersons]
		aValue.push(output)
		console.log(aValue, 'aValue is')
		setarrayofobjForpersons(aValue)
		console.log(arrayofobjForpersons, 'hiii')
	}

	const clicktosubmit = async () => {
		const persondata = await getPersondata()
				setaccordian(false)
		setpersondata(persondata)
		console.log(persondata, 'persondata123')
		const personames = []
		persondata.map(item => {
			personames.push(item.name_En)
			return personames
		})
		console.log(personames, 'personamespersonames') // personames

		const data = await getMovieDetailsFromWikiService()
		console.log(data, 'data123')
		if (data.items && data.items.length) {
			setwikkedata(data.items[0])
			console.log(data.items[0], 'moviedata=------')

			if (movesinput === '1234') {
				// if (persondata.length===0)
				// {
				// 	settrueval(true)
				// 	console.log('no data found')
				// }
				// if(persondata.length>0)
				// {
				// 	setaccordian(true)
				// 	settrueval(false)
				// }
				// console.log(data.items[0].cast_En[0].name, 'moviename')
				const datamap = data.items[0].cast_En
				console.log(datamap, 'datamap')
				const moviePersonames = []
				datamap.map(item => {
					const nametopush = item.name
					moviePersonames.push(nametopush)
					return (
						console.log(item.name, 'consoleitem')
					)
				})
				console.log(moviePersonames, 'movie_personamesmovie_personames')

				// let unmatched_cast_names = moviePersonames.filter(x => personames.indexOf(x) === -1)
				// let unmatched_cast_names = moviePersonames.filter(x => moviePersonames.indexOf(x) === -1)

				console.log(persondata, 'persondatapersondata')
				if (persondata.length === 0) {
					console.log('empty array')
					settrueval(true)
					setaccordian(false)
				}

				if (persondata.length > 0) {
					console.log(' nopn empty array')
					setaccordian(true)
					settrueval(false)
				}
		}			else {
				settrueval(false)
			}
		}
	}

useEffect(() => {
		const getMovieDataFromUrl = async () => {
			const dataFromWiki = await getMovieDetailsFromWikiService()
			console.log(dataFromWiki, 'dataFromWiki======')
			setdataFromWiki(dataFromWiki)
		}

		getMovieDataFromUrl()
	}, [])

console.log(dataFromWiki, 'dataFromWikidataFromWikidataFromWiki')
	console.log(movesinput)
	console.log(movesinput.length)

	// function open_editperson_form(){
	// 	console.log('open_editperson_form opend')
	// }
	const updateInputInParent = (formIndex, fieldname, fieldvalue) => {
		const existinginputArr = [...inputArr]
		const existingFormIndexObject = existinginputArr[formIndex]
const inputObject = { ...existingFormIndexObject }
inputObject[fieldname] = fieldvalue
existinginputArr[formIndex] = inputObject
setInputArr(existinginputArr)
	}

function submitAllForms() {
	setboolToCall(true)
}

	return (
		<div>
			{console.log(inputArr, 'inputArr====')}
			<p>Enter Wikipedia URL</p>
			<input type='text' onChange={Inputtextmovies} placeholder='enter movie name' />
			{movesinput === '' ? (
				<div>
					<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
						Wikipedia URL cannot be empty
					</text>
					<div>
						<button className='btn btn-primary' disabled >
							Import
						</button>
					</div>
				</div>
			) : null}
			{movesinput.length >= 1 ? (
				<div>
					<button className='btn btn-primary' style={{ marginTop: '3px' }}
						onClick={clicktosubmit}
						// onClick={submitform}

					>
						Import
					</button>

				</div>
			) : null}
			{/* {accordian?<><button onClick={open_editperson_form} className='accordion'>Section 1</button>
					<div className='panel'>
						<p></p>
					</div></>:''} */}
			<div>
				{trueval ? <EditMovie label={'Create Movie'} trueval={trueval} inputData={wikkedata} /> : ''}
			</div>
			{accordian ? persondata.map((item, formIndex) => (
					<div key={formIndex}>

						<div className='panel panel-default'>
							<div className='panel-heading'>
								<a data-toggle='collapse' data-parent='#accordion' href='#collapse1'>Person {persondata.indexOf(item)}</a>

							</div>
							<div id='collapse1' className='panel-collapse collapse in'>
								<div className='panel-body'>{item.name_En}</div>
								<CreatePerson persondata={persondata} item={item}
								updateInputInParent={updateInputInParent}
								formIndex={formIndex}
								boolToCall={boolToCall} multidataarray={multidataarray} />
							</div>

						</div>

					</div>
				)) : ''
			}
			<button onClick={submitAllForms} >Submit</button>
			<button>Translate</button>
		</div>
	)
}

export default ImportMovies
